import { useContext, useEffect, useState} from "react";
import { PermissionInterface } from "../../interfaces";
import  permissionService   from "../../services/PermissionService";
import { Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { faPencil, faTrash } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { JAlerta, JCaption, JCard, JCardBody, JConfirmDelete, JHeader, JPaginacao, JTable, JTBody, JTHead 
} from "../../components/Components";
import { AuthContext } from "../../contexts/AuthContext";

const initial: PermissionInterface = {
    id: "",
    name: "",
};

export default function IndexProfile() {
    const [dados, setDados] = useState<PermissionInterface[]>([]);
    const [showModal, setShowModal] = useState(false); 
    const [showSpinner, setShowSpinner] = useState(true);
    const [selected, setSelected] = useState<PermissionInterface>(initial);
    const [showError, setShowError] = useState(false);
    const [showMessageError, setShowMessageError] = useState('');
    const [search, setSearch] = useState('');
    const [meta, setMeta] = useState<any>(null)
    const [links, setLinks] = useState<any>(null)
    const navigate = useNavigate();
    const authContext = useContext(AuthContext);
    
    useEffect(() => {
        window.addEventListener("keydown", handleKeyDown)
        searchFilter();

        return () => {
            window.removeEventListener("keydown", handleKeyDown)
        }
    }, [search]);


    const handleKeyDown = (e: KeyboardEvent) => {
        if (e.key === 'Insert') {
            navigate('/profile/create');
        }
    }
    
    const searchFilter = async (page: string | null = null) =>  {
  
       setShowSpinner(true);
        
        await permissionService.getAllPaginate(search, page).then( response => {
            setDados(response.data);
            setLinks(response.links);
            setMeta(response.meta);
            setShowSpinner(false);
            
        }).catch(err => {
            if (err.response.status === 403) {
                authContext?.setShowError(true)
                authContext?.setShowMessageError(err.response.data.message);
                navigate('/');
            }
            setShowSpinner(false);
        });

    }

    const handleDelete = (id: string) => {
         
        permissionService.delete(id).then( data => {
            setDados(dados.filter( data => data.id !== id));
            setShowModal(false);
            
        }).catch(err => {
            const error400 = [403,400,409]

            if (error400.includes(err.response.status)) {
                
                setShowModal(false);
                setShowError(true)
                setShowMessageError(err.response.data.message)
            }
        });
    }

    const handlePageChange = (page: string | null = null) => {
        searchFilter(page)
    }

    const handleOpenModal = (conta: any) => {
        setSelected(conta);
        setShowModal(true);
    }

    const handleCloseModal = () => {
        setShowModal(false);
        setSelected(initial);
    }
   
    return (<>
        <JAlerta showError={showError} close={setShowError} messageError={showMessageError} time={3000} />           
        <div className="row d-flex justify-content-between align-items-start g-2">
            <Col md>
                <JCard>
                    <JHeader  
                        urlCreate="/permission/create"
                        search={search}
                        setSearch={setSearch}
                        showSpinner={showSpinner}
                        permissionCreate={authContext?.userLogado.is_staff}
                        permissionSearch={true}
                    >
                        
                    </JHeader>
                    <JCardBody>
                        <JCaption title="Lista de permissões disponíveis">
                            
                            <JPaginacao 
                                links={links ?? {}}
                                meta={meta ?? {}}
                                handlePageChange={handlePageChange} />
                        </JCaption>
                        <JTable >
                        
                            <JTHead>
                                <tr>
                                    {authContext?.userLogado.is_staff ? (
                                        <th style={{ width: '5rem' }} className="text-center">Ações</th>
                                    ) : (
                                        <></>
                                    )}
                                    <th>
                                        Nome da permissão
                                    </th>
                                </tr>
                            </JTHead>
                            <JTBody>
                                {dados?.map((data) => (
                                    <tr key={data.id}>
                                        {authContext?.userLogado.is_staff ? (
                                            <td className="text-center">
                                            <Link className="text-primary" to={`/permission/${data.id}`}>
                                                <FontAwesomeIcon icon={faPencil} />
                                            </Link>
                                            <button type="button" onClick={() => handleOpenModal(data)} 
                                                className="text-danger ms-2" 
                                                style={
                                                    { 
                                                        border: 'none', background: 'none', padding: '0', 
                                                        cursor: 'pointer' 
                                                    }
                                                }>
                                                    <FontAwesomeIcon icon={faTrash}/>
                                            </button>
                                        </td>
                                        ) : (<></>)}
                                        <td>{data.name}</td>
                                    </tr>
                                ))}                           
                            </JTBody>
                        </JTable>
                    </JCardBody>
                </JCard>
            </Col>
        </div>
        
        <JConfirmDelete 
            showModal={showModal} 
            handleCloseModal={handleCloseModal} 
            handleDelete={handleDelete} 
            selectedObject={selected?.name} 
            id={selected?.id}
        />
        
    </>);
};

